import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';

import {
  TipoDescuentoEnumChoice,
  emptyCellOneLevel,
  formatCurrencyCell,
  formatPercentageCell,
} from '@/shared';
import { SampleTable } from '@/shared/components/ui';
import { PromocionPreagendaType } from '@/shared/interfaces';

export type PromocionTablePreagendaProps = {
  promociones: PromocionPreagendaType[];
};

const PromocionTablePreagenda: React.FC<PromocionTablePreagendaProps> = ({
  promociones,
}) => {
  ///* colums --------------------
  const columns = useMemo<MRT_ColumnDef<PromocionPreagendaType>[]>(
    () => [
      {
        header: 'Nombre',
        accessorKey: 'nombre',
        Cell: ({ row }) => emptyCellOneLevel(row, 'nombre'),
      },
      {
        header: 'Código',
        accessorKey: 'codigo',
        Cell: ({ row }) => emptyCellOneLevel(row, 'codigo'),
      },
      {
        header: 'Tipo de Descuento',
        accessorKey: 'tipo_descuento',
        Cell: ({ row }) => emptyCellOneLevel(row, 'tipo_descuento'),
      },
      {
        header: 'Valor de Descuento',
        accessorKey: 'valor_descuento',
        Cell: ({ row }) => {
          if (
            row.original.tipo_descuento === TipoDescuentoEnumChoice.PORCENTAJE
          )
            return formatPercentageCell(row, 'valor_descuento');

          return formatCurrencyCell(row, 'valor_descuento');
        },
      },
    ],
    []
  );

  return (
    <>
      <SampleTable
        density="compact"
        columns={columns}
        data={promociones || []}
        enablePagination={true}
      />
    </>
  );
};

export default PromocionTablePreagenda;
